
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexfUUxdQ7_sx7E7QgcXHxXIC2vrQdyPvrdJgGQMBdfEOIMeta } from "/codebuild/output/src2956126409/src/storefront/pages/index.vue?macro=true";
import { default as loging3NXZY4lhPrW0AM__amCQLxd_m2gPL_45kmwhFaeE4uXAMeta } from "/codebuild/output/src2956126409/src/storefront/pages/login.vue?macro=true";
import { default as cookie824od824mbp_45eK2eJm0nqtuQajM4mXYqdxgMhBoQ5uoMeta } from "/codebuild/output/src2956126409/src/storefront/pages/cookie.vue?macro=true";
import { default as searchep9A8mncxb3eiMPHbSZoCn3zuPreTYYnkyyVW5vbMdAMeta } from "/codebuild/output/src2956126409/src/storefront/pages/search.vue?macro=true";
import { default as my_45cartH4Bae2Avd06eSdY16nijojhzZnLW01B4c7frCRVSrXoMeta } from "/codebuild/output/src2956126409/src/storefront/pages/my-cart.vue?macro=true";
import { default as on_45saley4em_455_458Us0S_45PLDt8wRTR9eB_451RDIhacQx0tA3F9lIMeta } from "/codebuild/output/src2956126409/src/storefront/pages/on-sale.vue?macro=true";
import { default as about_45us44gqbx9O_O4DfpRnJLGoTVS3CyXmjnr9h4VxyZuuI7QMeta } from "/codebuild/output/src2956126409/src/storefront/pages/about-us.vue?macro=true";
import { default as book_45clubFvn3Q_45n3Ww_45EbmftkbWTeP_45sY_45Wov922zrv6fPkCvgIMeta } from "/codebuild/output/src2956126409/src/storefront/pages/book-club.vue?macro=true";
import { default as contact_45ussZ4y3Kx5VHXxRb1sY_4Mth0KR7oO4qlB9YT5JeOfxcQMeta } from "/codebuild/output/src2956126409/src/storefront/pages/contact-us.vue?macro=true";
import { default as newspapersJieC6TvfoDyYLqZA8KqGEUCLUOGffgPD699rgxM_smIMeta } from "/codebuild/output/src2956126409/src/storefront/pages/newspapers.vue?macro=true";
import { default as _91slug_93tqC9t1HelbadiCx_45_45v_zzAdIEy5e3oDcz_45RWAKju010Meta } from "/codebuild/output/src2956126409/src/storefront/pages/book/[slug].vue?macro=true";
import { default as indexNiuUULzwT_450N9Z_nz3z72Xiut0_45PBtFn8gtALmzaKOMMeta } from "/codebuild/output/src2956126409/src/storefront/pages/books/index.vue?macro=true";
import { default as barion_45startXSkDOVurCuR1DdEdznLYOQbGw5fbb0pdTZ_448kWV1AMeta } from "/codebuild/output/src2956126409/src/storefront/pages/barion-start.vue?macro=true";
import { default as paypal_45start0oZVYEehBt7bQAyDBUeJTavUJwZEw3GJItgwxlygmlYMeta } from "/codebuild/output/src2956126409/src/storefront/pages/paypal-start.vue?macro=true";
import { default as _91_46_46_46catchAll_93AFHEuK64_StYUtacJBBkYUf_6yh3OsWfFhEpTtvxFBsMeta } from "/codebuild/output/src2956126409/src/storefront/pages/[...catchAll].vue?macro=true";
import { default as index1ypRGTQ18LdgbUShsCyOegQbJq6GH_45cDIY4vMYBd8jsMeta } from "/codebuild/output/src2956126409/src/storefront/pages/checkout/index.vue?macro=true";
import { default as payment_45resulthqwBqlihrmkS_45XSG7ipNJJohhLA_45F2qMugv2ZsPrKA8Meta } from "/codebuild/output/src2956126409/src/storefront/pages/payment-result.vue?macro=true";
import { default as privacy_45policyDOY_KqHWCYPlA0gJk9OwqTU2sPn9sa8hv0ndxQqlVaQMeta } from "/codebuild/output/src2956126409/src/storefront/pages/privacy-policy.vue?macro=true";
import { default as index8fDxpZSZeu4uEOQ1MovkB1vMcCQwoQw7HwiuZyqwN_45wMeta } from "/codebuild/output/src2956126409/src/storefront/pages/my-orders/index.vue?macro=true";
import { default as newly_45published6hA7jAXlZZ1roHSQgXLyN6zdlgX3UKLrtv0U_45wczDJ8Meta } from "/codebuild/output/src2956126409/src/storefront/pages/newly-published.vue?macro=true";
import { default as _91slug_93Ejl92nh7HCpNJQPYFFzEeweqAN2Myw7NAs7Hyva6u6IMeta } from "/codebuild/output/src2956126409/src/storefront/pages/my-orders/[slug].vue?macro=true";
import { default as thankyouic_45SUEOa39IPBhBdmaTOAxhcXYcI2R8PBCgEibjO9yoMeta } from "/codebuild/output/src2956126409/src/storefront/pages/checkout/thankyou.vue?macro=true";
import { default as upcoming_45releaseswtgbHf_P_45Y2K6irFCXcsZpeoKvxKKuICmhiw0d_VzwAMeta } from "/codebuild/output/src2956126409/src/storefront/pages/upcoming-releases.vue?macro=true";
import { default as terms_45and_45conditionsfcPNvgFiBP_0VEq_v2pS6KJ3X2_K7AN6hjAqkGI6mCwMeta } from "/codebuild/output/src2956126409/src/storefront/pages/terms-and-conditions.vue?macro=true";
import { default as _91slug_932XTgP6MaGLAr1Q3m7nbPNBrZ_45M2n5I9k1iUqkQSkNfwMeta } from "/codebuild/output/src2956126409/src/storefront/pages/other-language/[slug].vue?macro=true";
import { default as indexK1D4CHdDcmPTzCeUwHhBw7Q6VvaJjoZ4w35RK6ScDkEMeta } from "/codebuild/output/src2956126409/src/storefront/pages/other-languages/index.vue?macro=true";
import { default as staff_45recommendationst3g_3Xy9is1bzWmYaHwcqlpYHjT9p9NnHIA1RbFzWzgMeta } from "/codebuild/output/src2956126409/src/storefront/pages/staff-recommendations.vue?macro=true";
import { default as _91slug_93YrvBOkf_45JDb1JKQjElx5N2a39dtiuMecVydNkTE1V9kMeta } from "/codebuild/output/src2956126409/src/storefront/pages/books-by-author/[slug].vue?macro=true";
import { default as indexAlZWdCML9LjYROWNhJ8CnHT9dPMyCwmw45bo3ryDuJ8Meta } from "/codebuild/output/src2956126409/src/storefront/pages/books/[category]/index.vue?macro=true";
import { default as _91slug_93RhzpkR65S5TdTO3SG6zzVu7AuoNRgZ9E7GIGBJ2Ox_45gMeta } from "/codebuild/output/src2956126409/src/storefront/pages/menu-navigation/[slug].vue?macro=true";
import { default as bestsellers_45of_45the_45month37_451gW9MMd9mB4Wkf4p6CA5EGcIk4OD8K3n7TMvCl2oMeta } from "/codebuild/output/src2956126409/src/storefront/pages/bestsellers-of-the-month.vue?macro=true";
import { default as _91slug_93Is_faCT7zE6Mej2MywIUQuMhgTLUgwCYYbw9xmzdmhcMeta } from "/codebuild/output/src2956126409/src/storefront/pages/stationary-and-gift/[slug].vue?macro=true";
import { default as indexEd8yocYCRC_QngCU7fhVQnwcJOdcwwN7pRkrndrzPVcMeta } from "/codebuild/output/src2956126409/src/storefront/pages/stationary-and-gifts/index.vue?macro=true";
import { default as indexhHnGaisqXJtIKsCE1_45MuomeneNsh3mFzOR2arQGLp64Meta } from "/codebuild/output/src2956126409/src/storefront/pages/other-languages/[category]/index.vue?macro=true";
import { default as purchase_45and_45shipping_45conditionsAGPbvdkgjNsuDX3oPd_zXBX6SgX_45zFAcKmGvyI_45SQEUMeta } from "/codebuild/output/src2956126409/src/storefront/pages/purchase-and-shipping-conditions.vue?macro=true";
import { default as index87N_TL4TMNj3whqtcZ7Ktoo9dv3q_45eP6ATkAp2eSsoQMeta } from "/codebuild/output/src2956126409/src/storefront/pages/books/[category]/[subcategory]/index.vue?macro=true";
import { default as _91_91subcategory_93_93RYVfmG0Ls_4z11TI_Fq_8eqsPLC7SGoS1HuGu64mOYUMeta } from "/codebuild/output/src2956126409/src/storefront/pages/products/[[category]]/[[subcategory]].vue?macro=true";
import { default as indexJSP4ohfyTwsqjZL3ctl9gZTCU7ms3R76hWp797iahlEMeta } from "/codebuild/output/src2956126409/src/storefront/pages/stationary-and-gifts/[category]/index.vue?macro=true";
import { default as indexdIJmCr9RWdFb71yaNxSk5g_K3_oj6JfvkpCXC5sz_45AMMeta } from "/codebuild/output/src2956126409/src/storefront/pages/other-languages/[category]/[subcategory]/index.vue?macro=true";
import { default as index9zeQnCKcu36Bc6S9sTH9_dhc_cmepoopNqmFMZtYVd0Meta } from "/codebuild/output/src2956126409/src/storefront/pages/stationary-and-gifts/[category]/[subcategory]/index.vue?macro=true";
export default [
  {
    name: "index___hu",
    path: "/hu",
    meta: indexfUUxdQ7_sx7E7QgcXHxXIC2vrQdyPvrdJgGQMBdfEOIMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: indexfUUxdQ7_sx7E7QgcXHxXIC2vrQdyPvrdJgGQMBdfEOIMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/index.vue")
  },
  {
    name: "login___hu",
    path: "/hu/bejelentkezes",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/login.vue")
  },
  {
    name: "cookie___hu",
    path: "/hu/suti",
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/cookie.vue")
  },
  {
    name: "cookie___en",
    path: "/cookie",
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/cookie.vue")
  },
  {
    name: "search___hu",
    path: "/hu/kereses",
    meta: searchep9A8mncxb3eiMPHbSZoCn3zuPreTYYnkyyVW5vbMdAMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/search",
    meta: searchep9A8mncxb3eiMPHbSZoCn3zuPreTYYnkyyVW5vbMdAMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/search.vue")
  },
  {
    name: "my-cart___hu",
    path: "/hu/kosaram",
    meta: my_45cartH4Bae2Avd06eSdY16nijojhzZnLW01B4c7frCRVSrXoMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/my-cart.vue")
  },
  {
    name: "my-cart___en",
    path: "/my-cart",
    meta: my_45cartH4Bae2Avd06eSdY16nijojhzZnLW01B4c7frCRVSrXoMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/my-cart.vue")
  },
  {
    name: "on-sale___hu",
    path: "/hu/akciok",
    meta: on_45saley4em_455_458Us0S_45PLDt8wRTR9eB_451RDIhacQx0tA3F9lIMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/on-sale.vue")
  },
  {
    name: "on-sale___en",
    path: "/on-sale",
    meta: on_45saley4em_455_458Us0S_45PLDt8wRTR9eB_451RDIhacQx0tA3F9lIMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/on-sale.vue")
  },
  {
    name: "about-us___hu",
    path: "/hu/rolunk",
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/about-us.vue")
  },
  {
    name: "about-us___en",
    path: "/about-us",
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/about-us.vue")
  },
  {
    name: "book-club___hu",
    path: "/hu/konyvklub",
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/book-club.vue")
  },
  {
    name: "book-club___en",
    path: "/book-club",
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/book-club.vue")
  },
  {
    name: "contact-us___hu",
    path: "/hu/kapcsolat",
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/contact-us.vue")
  },
  {
    name: "contact-us___en",
    path: "/contact-us",
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/contact-us.vue")
  },
  {
    name: "newspapers___hu",
    path: "/hu/ujsagok-es-magazinok",
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/newspapers.vue")
  },
  {
    name: "newspapers___en",
    path: "/newspapers-and-magazines",
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/newspapers.vue")
  },
  {
    name: "book-slug___hu",
    path: "/hu/konyv/:slug()",
    meta: _91slug_93tqC9t1HelbadiCx_45_45v_zzAdIEy5e3oDcz_45RWAKju010Meta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/book/[slug].vue")
  },
  {
    name: "book-slug___en",
    path: "/book/:slug()",
    meta: _91slug_93tqC9t1HelbadiCx_45_45v_zzAdIEy5e3oDcz_45RWAKju010Meta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/book/[slug].vue")
  },
  {
    name: "books___hu",
    path: "/hu/konyvek",
    meta: indexNiuUULzwT_450N9Z_nz3z72Xiut0_45PBtFn8gtALmzaKOMMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/books/index.vue")
  },
  {
    name: "books___en",
    path: "/books",
    meta: indexNiuUULzwT_450N9Z_nz3z72Xiut0_45PBtFn8gtALmzaKOMMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/books/index.vue")
  },
  {
    name: "barion-start___hu",
    path: "/hu/barion-fizetes",
    meta: { ...(barion_45startXSkDOVurCuR1DdEdznLYOQbGw5fbb0pdTZ_448kWV1AMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/barion-start.vue")
  },
  {
    name: "barion-start___en",
    path: "/barion-start",
    meta: { ...(barion_45startXSkDOVurCuR1DdEdznLYOQbGw5fbb0pdTZ_448kWV1AMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/barion-start.vue")
  },
  {
    name: "paypal-start___hu",
    path: "/hu/paypal-fizetes",
    meta: { ...(paypal_45start0oZVYEehBt7bQAyDBUeJTavUJwZEw3GJItgwxlygmlYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/paypal-start.vue")
  },
  {
    name: "paypal-start___en",
    path: "/paypal-start",
    meta: { ...(paypal_45start0oZVYEehBt7bQAyDBUeJTavUJwZEw3GJItgwxlygmlYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/paypal-start.vue")
  },
  {
    name: "catchAll___hu",
    path: "/hu/:catchAll(.*)*",
    meta: _91_46_46_46catchAll_93AFHEuK64_StYUtacJBBkYUf_6yh3OsWfFhEpTtvxFBsMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/[...catchAll].vue")
  },
  {
    name: "catchAll___en",
    path: "/:catchAll(.*)*",
    meta: _91_46_46_46catchAll_93AFHEuK64_StYUtacJBBkYUf_6yh3OsWfFhEpTtvxFBsMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/[...catchAll].vue")
  },
  {
    name: "checkout___hu",
    path: "/hu/megrendeles",
    meta: { ...(index1ypRGTQ18LdgbUShsCyOegQbJq6GH_45cDIY4vMYBd8jsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/checkout/index.vue")
  },
  {
    name: "checkout___en",
    path: "/checkout",
    meta: { ...(index1ypRGTQ18LdgbUShsCyOegQbJq6GH_45cDIY4vMYBd8jsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/checkout/index.vue")
  },
  {
    name: "payment-result___hu",
    path: "/hu/barion-eredmeny",
    meta: { ...(payment_45resulthqwBqlihrmkS_45XSG7ipNJJohhLA_45F2qMugv2ZsPrKA8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/payment-result.vue")
  },
  {
    name: "payment-result___en",
    path: "/barion-result",
    meta: { ...(payment_45resulthqwBqlihrmkS_45XSG7ipNJJohhLA_45F2qMugv2ZsPrKA8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/payment-result.vue")
  },
  {
    name: "privacy-policy___hu",
    path: "/hu/adatkezelesi-tajekoztato",
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/privacy-policy.vue")
  },
  {
    name: "my-orders___hu",
    path: "/hu/rendeleseim",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/my-orders/index.vue")
  },
  {
    name: "my-orders___en",
    path: "/my-orders",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/my-orders/index.vue")
  },
  {
    name: "newly-published___hu",
    path: "/hu/ujdonsagok",
    meta: newly_45published6hA7jAXlZZ1roHSQgXLyN6zdlgX3UKLrtv0U_45wczDJ8Meta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/newly-published.vue")
  },
  {
    name: "newly-published___en",
    path: "/newly-published",
    meta: newly_45published6hA7jAXlZZ1roHSQgXLyN6zdlgX3UKLrtv0U_45wczDJ8Meta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/newly-published.vue")
  },
  {
    name: "my-orders-slug___hu",
    path: "/hu/rendeleseim/:slug()",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/my-orders/[slug].vue")
  },
  {
    name: "my-orders-slug___en",
    path: "/my-orders/:slug()",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/my-orders/[slug].vue")
  },
  {
    name: "checkout-thankyou___hu",
    path: "/hu/megrendeles-koszonjuk",
    meta: thankyouic_45SUEOa39IPBhBdmaTOAxhcXYcI2R8PBCgEibjO9yoMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/checkout/thankyou.vue")
  },
  {
    name: "checkout-thankyou___en",
    path: "/checkout-thankyou",
    meta: thankyouic_45SUEOa39IPBhBdmaTOAxhcXYcI2R8PBCgEibjO9yoMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/checkout/thankyou.vue")
  },
  {
    name: "upcoming-releases___hu",
    path: "/hu/varhato-megjelenesek",
    meta: upcoming_45releaseswtgbHf_P_45Y2K6irFCXcsZpeoKvxKKuICmhiw0d_VzwAMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/upcoming-releases.vue")
  },
  {
    name: "upcoming-releases___en",
    path: "/upcoming-releases",
    meta: upcoming_45releaseswtgbHf_P_45Y2K6irFCXcsZpeoKvxKKuICmhiw0d_VzwAMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/upcoming-releases.vue")
  },
  {
    name: "terms-and-conditions___hu",
    path: "/hu/altalanos-szerzodesi-feltetelek",
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___en",
    path: "/terms-and-conditions",
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/terms-and-conditions.vue")
  },
  {
    name: "other-language-slug___hu",
    path: "/hu/egyeb-idegen-nyelvu-konyv/:slug()",
    meta: _91slug_932XTgP6MaGLAr1Q3m7nbPNBrZ_45M2n5I9k1iUqkQSkNfwMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/other-language/[slug].vue")
  },
  {
    name: "other-language-slug___en",
    path: "/other-language/:slug()",
    meta: _91slug_932XTgP6MaGLAr1Q3m7nbPNBrZ_45M2n5I9k1iUqkQSkNfwMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/other-language/[slug].vue")
  },
  {
    name: "other-languages___hu",
    path: "/hu/egyeb-idegen-nyelvu-konyvek",
    meta: indexK1D4CHdDcmPTzCeUwHhBw7Q6VvaJjoZ4w35RK6ScDkEMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/other-languages/index.vue")
  },
  {
    name: "other-languages___en",
    path: "/other-languages",
    meta: indexK1D4CHdDcmPTzCeUwHhBw7Q6VvaJjoZ4w35RK6ScDkEMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/other-languages/index.vue")
  },
  {
    name: "staff-recommendations___hu",
    path: "/hu/mi-ajanljuk",
    meta: staff_45recommendationst3g_3Xy9is1bzWmYaHwcqlpYHjT9p9NnHIA1RbFzWzgMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/staff-recommendations.vue")
  },
  {
    name: "staff-recommendations___en",
    path: "/staff-recommendations",
    meta: staff_45recommendationst3g_3Xy9is1bzWmYaHwcqlpYHjT9p9NnHIA1RbFzWzgMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/staff-recommendations.vue")
  },
  {
    name: "books-by-author-slug___hu",
    path: "/hu/szerzo-muvei/:slug()",
    meta: _91slug_93YrvBOkf_45JDb1JKQjElx5N2a39dtiuMecVydNkTE1V9kMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/books-by-author/[slug].vue")
  },
  {
    name: "books-by-author-slug___en",
    path: "/books-by-author/:slug()",
    meta: _91slug_93YrvBOkf_45JDb1JKQjElx5N2a39dtiuMecVydNkTE1V9kMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/books-by-author/[slug].vue")
  },
  {
    name: "books-category___hu",
    path: "/hu/konyvek/:category()",
    meta: indexAlZWdCML9LjYROWNhJ8CnHT9dPMyCwmw45bo3ryDuJ8Meta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/books/[category]/index.vue")
  },
  {
    name: "books-category___en",
    path: "/books/:category()",
    meta: indexAlZWdCML9LjYROWNhJ8CnHT9dPMyCwmw45bo3ryDuJ8Meta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/books/[category]/index.vue")
  },
  {
    name: "menu-navigation-slug___hu",
    path: "/hu/menu-navigacio/:slug()",
    meta: _91slug_93RhzpkR65S5TdTO3SG6zzVu7AuoNRgZ9E7GIGBJ2Ox_45gMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/menu-navigation/[slug].vue")
  },
  {
    name: "menu-navigation-slug___en",
    path: "/menu-navigation/:slug()",
    meta: _91slug_93RhzpkR65S5TdTO3SG6zzVu7AuoNRgZ9E7GIGBJ2Ox_45gMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/menu-navigation/[slug].vue")
  },
  {
    name: "bestsellers-of-the-month___hu",
    path: "/hu/a-honap-sikerkonyvei",
    meta: bestsellers_45of_45the_45month37_451gW9MMd9mB4Wkf4p6CA5EGcIk4OD8K3n7TMvCl2oMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/bestsellers-of-the-month.vue")
  },
  {
    name: "bestsellers-of-the-month___en",
    path: "/bestsellers-of-the-month",
    meta: bestsellers_45of_45the_45month37_451gW9MMd9mB4Wkf4p6CA5EGcIk4OD8K3n7TMvCl2oMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/bestsellers-of-the-month.vue")
  },
  {
    name: "stationary-and-gift-slug___hu",
    path: "/hu/notesz-es-ajandektargy/:slug()",
    meta: _91slug_93Is_faCT7zE6Mej2MywIUQuMhgTLUgwCYYbw9xmzdmhcMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/stationary-and-gift/[slug].vue")
  },
  {
    name: "stationary-and-gift-slug___en",
    path: "/stationary-and-gift/:slug()",
    meta: _91slug_93Is_faCT7zE6Mej2MywIUQuMhgTLUgwCYYbw9xmzdmhcMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/stationary-and-gift/[slug].vue")
  },
  {
    name: "stationary-and-gifts___hu",
    path: "/hu/noteszek-es-ajandektargyak",
    meta: indexEd8yocYCRC_QngCU7fhVQnwcJOdcwwN7pRkrndrzPVcMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/stationary-and-gifts/index.vue")
  },
  {
    name: "stationary-and-gifts___en",
    path: "/stationary-and-gifts",
    meta: indexEd8yocYCRC_QngCU7fhVQnwcJOdcwwN7pRkrndrzPVcMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/stationary-and-gifts/index.vue")
  },
  {
    name: "other-languages-category___hu",
    path: "/hu/egyeb-idegen-nyelvu-konyvek/:category()",
    meta: indexhHnGaisqXJtIKsCE1_45MuomeneNsh3mFzOR2arQGLp64Meta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/other-languages/[category]/index.vue")
  },
  {
    name: "other-languages-category___en",
    path: "/other-languages/:category()",
    meta: indexhHnGaisqXJtIKsCE1_45MuomeneNsh3mFzOR2arQGLp64Meta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/other-languages/[category]/index.vue")
  },
  {
    name: "purchase-and-shipping-conditions___hu",
    path: "/hu/vasarlasi-es-szallitasi-feltetelek",
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/purchase-and-shipping-conditions.vue")
  },
  {
    name: "purchase-and-shipping-conditions___en",
    path: "/purchase-and-shipping-conditions",
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/purchase-and-shipping-conditions.vue")
  },
  {
    name: "books-category-subcategory___hu",
    path: "/hu/konyvek/:category()/:subcategory()",
    meta: index87N_TL4TMNj3whqtcZ7Ktoo9dv3q_45eP6ATkAp2eSsoQMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/books/[category]/[subcategory]/index.vue")
  },
  {
    name: "books-category-subcategory___en",
    path: "/books/:category()/:subcategory()",
    meta: index87N_TL4TMNj3whqtcZ7Ktoo9dv3q_45eP6ATkAp2eSsoQMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/books/[category]/[subcategory]/index.vue")
  },
  {
    name: "products-category-subcategory___hu",
    path: "/hu/product/:category?/:subcategory?",
    meta: _91_91subcategory_93_93RYVfmG0Ls_4z11TI_Fq_8eqsPLC7SGoS1HuGu64mOYUMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/products/[[category]]/[[subcategory]].vue")
  },
  {
    name: "products-category-subcategory___en",
    path: "/products/:category?/:subcategory?",
    meta: _91_91subcategory_93_93RYVfmG0Ls_4z11TI_Fq_8eqsPLC7SGoS1HuGu64mOYUMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/products/[[category]]/[[subcategory]].vue")
  },
  {
    name: "stationary-and-gifts-category___hu",
    path: "/hu/noteszek-es-ajandektargyak/:category()",
    meta: indexJSP4ohfyTwsqjZL3ctl9gZTCU7ms3R76hWp797iahlEMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/stationary-and-gifts/[category]/index.vue")
  },
  {
    name: "stationary-and-gifts-category___en",
    path: "/stationary-and-gifts/:category()",
    meta: indexJSP4ohfyTwsqjZL3ctl9gZTCU7ms3R76hWp797iahlEMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/stationary-and-gifts/[category]/index.vue")
  },
  {
    name: "other-languages-category-subcategory___hu",
    path: "/hu/egyeb-idegen-nyelvu-konyvek/:categorysubcategory?",
    meta: indexdIJmCr9RWdFb71yaNxSk5g_K3_oj6JfvkpCXC5sz_45AMMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/other-languages/[category]/[subcategory]/index.vue")
  },
  {
    name: "other-languages-category-subcategory___en",
    path: "/other-languages/:category()/:subcategory()",
    meta: indexdIJmCr9RWdFb71yaNxSk5g_K3_oj6JfvkpCXC5sz_45AMMeta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/other-languages/[category]/[subcategory]/index.vue")
  },
  {
    name: "stationary-and-gifts-category-subcategory___hu",
    path: "/hu/noteszek-es-ajandektargyak/:categorysubcategory?",
    meta: index9zeQnCKcu36Bc6S9sTH9_dhc_cmepoopNqmFMZtYVd0Meta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/stationary-and-gifts/[category]/[subcategory]/index.vue")
  },
  {
    name: "stationary-and-gifts-category-subcategory___en",
    path: "/stationary-and-gifts/:category()/:subcategory()",
    meta: index9zeQnCKcu36Bc6S9sTH9_dhc_cmepoopNqmFMZtYVd0Meta || {},
    component: () => import("/codebuild/output/src2956126409/src/storefront/pages/stationary-and-gifts/[category]/[subcategory]/index.vue")
  }
]